/**
 * <popup-sheet> — pop-up automático (sections/pop-up.liquid). É a janela do tema (<side-sheet> no centro)
 * que abre sozinha:
 *   data-mode="live"        → abre depois de data-delay segundos; fechado uma vez, não volta
 *                              (theme.storageKeys.popupDismissedKey)
 *   data-mode="development" → abre sempre, 2s depois de carregar (para testar)
 * No editor não abre sozinho (o lojista abre selecionando a seção).
 *
 * Carregado pela própria seção. Depende de base.js (SideSheet, theme.storageKeys).
 */
(function () {
  "use strict";

  if (customElements.get("popup-sheet") || !window.SideSheet) return;

  var storage = {
    get: function (key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    },
    set: function (key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* navegação privada */ }
    },
  };

  class PopupSheet extends window.SideSheet {
    init() {
      super.init();
      if (window.Shopify && window.Shopify.designMode) return;

      var live = this.dataset.mode === "live";
      var key = theme.storageKeys.popupDismissedKey;
      if (live && storage.get(key) === "true") return;

      if (live) {
        this.addEventListener("sheet:close", function () { storage.set(key, "true"); }, {
          signal: this.__tdController.signal,
          once: true,
        });
      }

      var wait = live ? (parseInt(this.dataset.delay, 10) || 0) * 1000 : 2000;
      this.__timer = window.setTimeout(this.open.bind(this), wait);
    }

    onEditorSectionSelect() {
      this.open();
    }

    onEditorSectionDeselect() {
      this.close();
    }

    destroy() {
      window.clearTimeout(this.__timer);
      super.destroy();
    }
  }

  customElements.define("popup-sheet", PopupSheet);
})();
